// models/Config.js

export class NavItem {
  constructor({ icon, name, path }) {
    this.icon = icon || '';
    this.name = name || '';
    this.path = path || '/';
  }
}

export class Button {
  constructor({ name, path }) {
    this.name = name || '';
    this.path = path || '/';
  }
}

export class NavbarConfig {
  constructor({ logo, logo_name, bg_color, items, extraBtn, noBackground, backgroundShape }) {
    this.bg_color = bg_color;
    this.items = (items || []).map(item => new NavItem(item));
    this.extraBtn = new Button(extraBtn);
    this.noBackground = noBackground;
    this.logo = logo;
    this.logo_name = logo_name;
    this.backgroundShape = backgroundShape;
  }
}



export class Section1Config {
  constructor({ bg_color, title, subtitle, buttons, images }) {
    this.bg_color = bg_color;
    this.title = title || '';
    this.subtitle = subtitle || '';
    this.buttons = (buttons || []).map(btn => new Button(btn));
    this.images = images;
  }
}

export class ConfigModel {
  constructor({ navbar, homepage, servicepage, aboutpage, contactpage, careerpage, footer }) {
    this.navbar = new NavbarConfig(navbar || {});
    this.homepage = new HomePageConfig(homepage || {});
    this.servicepage = new HomePageConfig(servicepage || {});
    this.aboutpage = new HomePageConfig(aboutpage || {});
    this.contactpage = new HomePageConfig(contactpage || {});
    this.careerpage = new HomePageConfig(careerpage || {}); 
    this.footer = new FooterConfig(footer || {});
  }
}

export class HomePageConfig {
  constructor({ sequence, section_1, section_2, section_3, section_4, section_5, section_6, section_7, section_8, section_9, section_10, section_11, section_12, survey_form_1, survey_form_2, office_card }) {
    this.sequence = sequence;
    this.section_1 = new Section1Config(section_1 || {});
    this.section_2 = new Section2Config(section_2 || {});
    this.section_3 = new Section3Config(section_3 || {});
    this.section_4 = new Section4Config(section_4 || {});
    this.section_5 = new Section5Config(section_5 || {});
    this.section_6 = new Section2Config(section_6 || {});
    this.section_7 = new Section2Config(section_7 || {});
    this.section_8 = new Section6Config(section_8 || {});
    this.section_9 = new Section7Config(section_9 || {});
    this.section_10 = new Section10Config(section_10 || {});
    this.section_11 = new Section11Config(section_11 || {});
    this.section_12 = new Section12Config(section_12 || {});
    this.survey_form_1 = new SurveyForm1(survey_form_1 || {});
    this.survey_form_2 = new SurveyForm1(survey_form_2 || {});
    this.office_card = office_card;
  }
}

export class SurveyForm1 {
  constructor({ path }) {
    this.path = path || '';
  }
}


export class Section2Item {
  constructor({ icon, itemCount, title, subtitle }) {
    this.icon = icon || '';
    this.title = title || '';
    this.subtitle = subtitle || '';
  }
}

export class Section2Config {
  constructor({ title, itemCount, items }) {
    this.title = title || '';
    this.itemCount = itemCount || 0;
    this.items = (items || []).map(item => new Section2Item(item));
  }
}

export class Section3Card {
  constructor({ icon, number, title, subtitle }) {
    this.icon = icon || '';
    this.number = number || '';
    this.title = title || '';
    this.subtitle = subtitle || '';
  }
}

export class Section3Button {
  constructor({ name, path, primary }) {
    this.name = name || '';
    this.path = path || '/';
    this.primary = primary || false;
  }
}

export class Section3Config {
  constructor({ heading, title, subtitle, itemCount, cards, buttons, heading_bgcolor, isItemsCardVisible, bg_animation, isCard }) {
    this.heading = heading || '';
    this.title = title || '';
    this.subtitle = subtitle || '';
    this.itemCount = itemCount|| 0;
    this.cards = (cards || []).map(card => new Section3Card(card));
    this.buttons = (buttons || []).map(btn => new Section3Button(btn));
    this.heading_bgcolor = heading_bgcolor;
    this.isItemsCardVisible = isItemsCardVisible;
    this.bg_animation = bg_animation;
    this.isCard = isCard;
  }
}

export class Section4Step {
  constructor({ title, subtitle }) {
    this.title = title || '';
    this.subtitle = subtitle || '';
  }
}

export class Section4Config {
  constructor({ title, steps }) {
    this.title = title || '';
    this.steps = (steps || []).map(step => new Section4Step(step));
  }
}

export class Section5Stat {
  constructor({ number, subtitle, description }) {
    this.number = number || '';
    this.subtitle = subtitle || '';
    this.description = description || '';
  }
}

export class Section5Config {
  constructor({ title, stats }) {
    this.title = title || '';
    this.stats = (stats || []).map(stat => new Section5Stat(stat));
  }
}

export class FAQItem {
  constructor({ question, answer }) {
    this.question = question || '';
    this.answer = answer || '';
  }
}

export class Section6Config {
  constructor({ title, faqs }) {
    this.title = title || '';
    this.faqs = (faqs || []).map(faq => new FAQItem(faq));
  }
}

export class Section7Config {
  constructor({ title, description, buttons, bg_color, isCard }) {
    this.title = title || '';
    this.description = description || '';
    this.buttons = (buttons || []).map(btn => new Section3Button(btn));
    this.bg_color = bg_color;
    this.isCard = isCard;
  }
}

export class Section10Config {
  constructor({ stats }) {
    this.stats = (stats || []).map(item => new Section10Item(item));
  }
}

export class Section10Item {
  constructor({ icon, number, title, description }) {
    this.icon = icon || '';
    this.number = number || '';
    this.title = title || '';
    this.description = description || '';
  }
}


export class Section11Config {
  constructor({ title, heading, subtitle, itemCount, items }){
    this.title = title || '';
    this.heading = heading || '';
    this.subtitle = subtitle || '';
    this.itemCount = itemCount || 0;
    this.items = (items || []).map(item => new Section11Item(item));
  }
}

export class Section11Item {
  constructor({ icon, count, title, subtitle }) {
    this.icon = icon || '';
    this.count = count || '';
    this.title = title || '';
    this.subtitle = subtitle || '';
  }
}



export class SocialIcon {
  constructor({ name, url }) {
    this.name = name || '';
    this.url = url || '';
  }
}

export class ContactInfo {
  constructor({ address, mobile, email }) {
    this.address = address || '';
    this.mobile = mobile || '';
    this.email = email || '';
  }
}

export class FooterConfig {
  constructor({ logo, description, social_icons, contact, quickLinks, bg_color }) {
    this.logo = logo || '';
    this.description = description || '';
    this.social_icons = (social_icons || []).map(icon => new SocialIcon(icon));
    this.contact = new ContactInfo(contact);
    this.quickLinks = (quickLinks || []).map(item => new NavItem(item));
    this.bg_color = bg_color;
  }
}

// Class for individual job item
export class Section12Item {
  constructor({ id, icon, title, jobtype, address, description, chips, enabled }) {
    this.id = id;
    this.icon = icon || '';
    this.title = title || '';
    this.jobtype = jobtype || '';
    this.address = address || '';
    this.description = description || '';
    this.chips = chips;
    this.enabled = enabled ?? true; // default true if not specified
  }
}

// Class for Section12 configuration
export class Section12Config {
  constructor({ title, subtitle, items }) {
    this.title = title || '';
    this.subtitle = subtitle || '';
    this.items = (items || []).map(item => new Section12Item(item));
  }
}